import React, { useState, useEffect } from "react";
import { useSearchParams } from "react-router-dom";
import TopBar from "../components/TopBar";
import MainNavigation from "../components/MainNavigation";
import MyPrompt from "../components/sections/MyPrompt";
import RatePrompt from "../components/sections/RatePrompt";
import PromptsView from "../components/sections/PromptsView";
import PromptCentral from "../components/sections/PromptCentral";
import MyLibrary from "../components/sections/MyLibrary";
import "./LandingPage.css";

const LandingPage = () => {
  const [searchParams, setSearchParams] = useSearchParams();
  const [activeTab, setActiveTab] = useState("my-prompt");

  // Update active tab based on URL params
  useEffect(() => {
    const tab = searchParams.get("tab");
    if (
      tab &&
      ["my-prompt", "rate-prompt", "all-prompts", "prompt-central"].includes(
        tab
      )
    ) {
      setActiveTab(tab);
    }
  }, [searchParams]);

  // Handle tab change and update URL
  const handleTabChange = (tabId) => {
    setActiveTab(tabId);
    setSearchParams({ tab: tabId });
  };

  // Render the active component
  const renderActiveComponent = () => {
    switch (activeTab) {
      case "my-prompt":
        return <MyPrompt />;
      case "all-prompts":
        return <PromptsView />;
      case "my-library":
        return <MyLibrary />;
      default:
        return <MyPrompt />;
    }
  };

  return (
    <div className="landing-page">
      <TopBar />
      <MainNavigation activeTab={activeTab} onTabChange={handleTabChange} />

      <div className="main-content">{renderActiveComponent()}</div>
    </div>
  );
};

export default LandingPage;
